module.exports = __webpack_public_path__ + "static/media/get-involved2.74cd05ef.jpg";